<script>
import Core from '../core/core-class';

/**
 * @example {@lang xml}
 * <template>
 *   <t-toggle @change="onChange">
 *     <t-toggle-button tag="a" onClass="active">tab1</t-toggle-button>
 *     <t-toggle-content classes="cont">content1</t-toggle-content>
 *   </t-toggle>
 * </template>
 *
 * @example
 * export default {
 *   methods: {
 *     onChange({ act }) {
 *       this.activate = act;
 *     }
 *   }
 * }
 *
 * @vue-data {Core} core - 코어 js
 * @vue-data {Number} selectedIndex - 선택 index
 * @vue-prop {String} tag="div" - 컴포넌트 root tag
 * @vue-prop {Array} classes - css class
 * @vue-prop {Number} activateIndex - 외부 data 바인딩될 활성화 값
 * @vue-prop {String} onClass - 활성화 css class명
 * @vue-computed {Array} classArr - onClass 속성과 병합된 css클래스
 */
export default {
  render(h) {
    const defaultSlot = this.$slots.default;
    return h(
      this.tag,
      {
        staticClass: this.classArr
      },
      defaultSlot
    );
  },
  name: 't-toggle',
  data() {
    return {
      core         : null,
      selectedIndex: null
    };
  },
  props: {
    tag: {
      type   : String,
      default: 'div'
    },
    classes: {
      type   : Array,
      default: () => []
    },
    activateIndex: {
      type   : Number,
      default: null
    },
    onClass: {
      type   : String,
      default: null
    }
  },
  computed: {
    classArr() {
      return ['t-toggle-container', ...this.classes];
    }
  },
  beforeMount() {
    this.core = new Core({ toggle: this });
    this.core.init();
  },
  mounted() {
    if (this.$route.hash) {
      if (this.$route.hash === '#none') {
        this.selectedIndex = 0;
      }
    } else {
      // url에 hash 정보가 없다면 외부 data 값에 의해 활성화 변경
      if (this.activateIndex !== null) {
        this.selectedIndex = this.activateIndex;
      }
    }
  },
  watch: {
    selectedIndex(value) {
      this.$emit('change', { act: value });
    },
    $route() {
      this.core.changeHash();
    }
  },
  methods: {
    // ttoggle-button 에서 호출
    change({ index, hash }) {
      console.log('change ', index, ' hash ', hash);
      this.selectedIndex = index;

      if (hash) {
        // this.replaceHash(hash); // router-link 와 동기화 하지못해 location.hash 대체
        location.hash = hash;
      }
    },
    // history 변화 없이 url 변경
    replaceHash(value) {
      const { pathname, search } = window.location;

      const lastPath = pathname.replaceAll(/(.+)\/|(\/)/g, '');

      // e.g) sub + ?aaaa=1111 + #tab1
      history.replaceState(null, '', `${lastPath + search + value}`);
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  cursor: pointer;
}
</style>
